import React, { useState } from "react";
import { ButtonGroup, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { MarketSerialBatchState, useChoiceLabel } from "@/const";
import { useRequest } from "@components/AppHook";
import { DevForm, SimpleLenCount } from "@components/Forms/Fields";
import { OverflowArea } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function MarketSerialsModerationScreen() {
    const { t } = useTranslation();
    const params = useParams();
    const header = t("Модерация ключей");
    return (
        <DefaultLayout>{params.id ? <Edit header={header} id={params.id} /> : <List header={header} />}</DefaultLayout>
    );
}

function List({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:moderation:market_serial:list"));

    if (!apiData) return;

    return (
        <ListingCard header={header}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Игра")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj) => (
                        <tr key={obj.id}>
                            <td>
                                <Link to={url_reverse("admin:moderation:market_serial:edit", { game_id: obj.id })}>
                                    {obj.__model_locale_object.name}
                                </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Edit({ id, header }) {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(
        url_reverse("api:moderation:market_serial:edit", { game_id: id })
    );
    const [comment, setComment] = useState({});
    const MarketSerialBatchSerialTypeTrans = useChoiceLabel("MarketSerialBatchSerialType");
    const { api_post } = useRequest();

    if (!apiData) return;

    const handleSubmit = (ev) => {
        const oid = parseInt(ev.target.value);
        const state = ev.target.name;
        const params = { id: oid, state, comment: comment[oid] };
        api_post(ev, apiUrl, {
            params,
            then: (resp) => {
                if (resp.status === "ok") {
                    const newApiData = { ...apiData };
                    newApiData.object_list = newApiData.object_list.filter((o) => o.id !== oid);
                    setApiData(newApiData);
                }
            },
        });
    };

    const cardHeader = (
        <>
            {header} &mdash;{" "}
            <Link to={url_reverse("games:admin", { game_id: apiData.game.id })}>
                {apiData.game.__model_locale_object.name}
            </Link>
        </>
    );
    return (
        <ListingCard header={cardHeader}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>{t("Количество")}</th>
                        <th style={{ width: "500px" }}>{t("Комментарий")}</th>
                        <th>{t("Тип ключей")}</th>
                        <th>
                            {t("Комментарий модератора")} ({apiData.contact_lang})
                        </th>
                        <th>{t("Действие")}</th>
                        <th style={{ width: "250px" }} />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj) => (
                        <tr key={obj.id}>
                            <td>{obj.id}</td>
                            <td>{obj.amount}</td>
                            <td className="show-wrap-text">
                                <OverflowArea y={150}>
                                    {obj.state === MarketSerialBatchState.NEW ? obj.comment : obj.comment_ban}
                                </OverflowArea>
                            </td>
                            <td>{MarketSerialBatchSerialTypeTrans[obj.serial_type]}</td>
                            <td>
                                <DevForm.TextArea
                                    name="comment"
                                    value={comment[obj.id]}
                                    onChange={(ev) => setComment((prev) => ({ ...prev, [obj.id]: ev.target.value }))}
                                    maxLength={1024}
                                />
                                <SimpleLenCount val={comment[obj.id]} maxLength={1024} />
                            </td>
                            <td>{obj.state === MarketSerialBatchState.NEW ? t("Генерация") : t("Бан")}</td>
                            <td>
                                <ButtonGroup>
                                    <DevForm.Button
                                        variant="success"
                                        name="approved"
                                        value={obj.id}
                                        onClick={handleSubmit}
                                    >
                                        {t("Принять")}
                                    </DevForm.Button>
                                    <DevForm.Button
                                        variant="danger"
                                        name="rejected"
                                        value={obj.id}
                                        onClick={handleSubmit}
                                    >
                                        {t("Отклонить")}
                                    </DevForm.Button>
                                </ButtonGroup>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}
